import { Wrapper } from '@klv/utils/wrapper';

import * as styles from './styles/twoColumn.module.scss';
import { TwoColumnHeader } from './two-column-header';
import { TwoColumnBody } from './two-column-body';
import { TwoColumnMedia } from './two-column-media';

import type { ITwoColumn } from './types';

const TwoColumn = ({
  backgroundColor = 'light',
  body,
  buttons,
  customPadding = { customPaddingBottom: 'md', customPaddingTop: 'md' },
  eyebrow = '',
  headline = '',
  fadeIn = false,
  mediaAlignment,
  subhead = '',
  mixedMedia,
  CustomContent,
  MediaCustomContent,
  useVideoModal = false,
  videoModalContent = {
    videoHeadline: ' ',
    videoUrl: '',
    videoDuration: '',
    image: {
      altText: '',
    },
  },
}: ITwoColumn) => {
  return (
    <Wrapper customPadding={customPadding} backgroundColor={backgroundColor} fadeIn={fadeIn ? .25 : 0}>
      <div>
        <div className={`grid ${styles.grid}`}>
          <TwoColumnHeader 
            eyebrow={eyebrow}
            headline={headline}
            subhead={subhead}
            mediaAlignment={mediaAlignment}
          />
          <TwoColumnBody
            body={body}
            buttons={buttons}
            backgroundColor={backgroundColor}
            mediaAlignment={mediaAlignment}
            CustomContent={CustomContent}
          />
          <TwoColumnMedia
            mixedMedia={mixedMedia}
            useVideoModal={useVideoModal}
            videoModalContent={videoModalContent}
            mediaAlignment={mediaAlignment}
            MediaCustomContent={MediaCustomContent}
          />
        </div>
      </div>
    </Wrapper>
  );
};

export default TwoColumn;
